import React, { useEffect, useState } from "react";
import { Button, IconButton } from '@mui/material';
import DataTable from '../components/DataTable';
import PageTitle from '../components/PageTitle';
import { Container } from "@mui/system";
import { Link } from "react-router-dom";
import { Grid } from "@mui/material";
import * as endPoint from "../assets/js/endpoints";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { ACTION_ICON_COLORS } from '../constants/iconActionColors';
import { useConfirm } from '../assets/contexts/confirmContext';
import { useLocation } from "react-router-dom";
import Loader from '../components/loader';
import AddIcon from '@mui/icons-material/Add';
import { useNotification } from '../assets/contexts/notificationContext';
import { Helmet } from 'react-helmet';

export default function Roles() {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [roles, setRoles] = useState([]);
  const confirm = useConfirm();
  const { showNotification } = useNotification();

  const getRoles = async () => {
    try {
      let roles = await endPoint.getAllRoles();
      setRoles(roles);
    } catch (_err) {
      showNotification('Error al obtener roles', 'error');
    }
  };

  const load = () => {
    setLoading(true);
    getRoles();
    setLoading(false);
  };

  useEffect(() => {
    load();
  }, []);

  if (loading) {
    return <Loader />;
  }

  const columns = [
    { id: 'id', label: 'ID' },
    { id: 'name', label: 'Nombre' },
    { id: 'guard_name', label: 'Guard' },
  ];

  const rows = roles;

  const actions = rol => (
    <>
      <IconButton component={Link} to={`${location.pathname}/editar/${rol.id}`} sx={{ color: ACTION_ICON_COLORS.edit }}>
        <EditIcon />
      </IconButton>
      <IconButton
        sx={{ color: ACTION_ICON_COLORS.delete }}
        onClick={async () => {
          const ok = await confirm('¿Eliminar rol?');
          if (!ok) return;
          try {
            await endPoint.deleteRol(rol.id);
            showNotification('Rol eliminado', 'success');
            load();
          } catch (_err) {
            showNotification('Error eliminando rol', 'error');
          }
        }}
      >
        <DeleteIcon />
      </IconButton>
    </>
  );

  return (
        <>
        <Helmet>
          <title>Lista de Roles | CES</title>
        </Helmet>
        <Container sx={{ mt:5, paddingBottom:2, mb:2 }}>
        <Grid
          container
          spacing={2}
          px={3}
          alignItems="center"
          justifyContent="space-between"
        > 
          <Grid item xs={12} sm={3} sx={{ display:'flex', justifyContent:'space-between', alignItems:'center',}}>
            <PageTitle>Lista de roles</PageTitle>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Link to={`${location.pathname}/crear`}>
              <Button variant="contained" color="primary" startIcon={<AddIcon />}>
                Crear rol
              </Button>
            </Link>
          </Grid>
        </Grid>

        <DataTable columns={columns} rows={rows} actions={actions} />
      </Container>
        </>
  );
}
